<template>
    <div class="bookConfigAdd app-container">
        <div class="app-table-container">
            <el-row :gutter="20">
                <el-col :span="12">
                    <dataTable :tableId="'table-first'" :tableData="tableData" :tableProps="tableProps1" :tableTitle="$t('org.selectedlibrary')">
                        <!-- <pagination
                        layout="prev, pager, next"
                        /> -->
                    </dataTable>
                </el-col>
                <el-col :span="12">
                    <dataTable :tableId="'table-second'" :tableData="tableData" :tableProps="tableProps2" :tableTitle="$t('org.optionallibrary')">
                        <!-- <pagination
                        layout="prev, pager, next"
                        /> -->
                    </dataTable>
                </el-col>
            </el-row>
        </div>
        <div class="bookConfigAdd-save">
            <el-button type="primary">{{$t('commonMsg.save')}}</el-button>
        </div>     
    </div>
</template>


<script>
import dataTable from '@/components/dataTable'
import pagination from '@/components/pagination'

export default {
    components: {
        dataTable,
        pagination
    },
    computed: {
        tableProps1() {
            let tableProps1 = [{
                prop: 'library',
                label: this.$t('org.library')
            }, {
                prop: 'handle',
                label: this.$t('commonMsg.handle'),
                btn: [this.$t('commonMsg.remove')]
            }]
            return tableProps1
        },
        tableProps2() {
            let  tableProps2 = [{
                prop: 'library',
                label: this.$t('org.library')
            }, {
                prop: 'handle',
                label: this.$t('commonMsg.handle'),
                btn: [this.$t('commonMsg.add')]
            }]
            return tableProps2
        },
    },
    data() {
        return {

            tableData: [{
                library: '校园阅读系统'
            }, {
                library: '家长学校'
            }, {
                library: '心理健康平台'
            }]
        }
    }
}
</script>

<style lang="scss" scoped>
    .bookConfigAdd{
        .bookConfigAdd-save{
            text-align: center;
            margin-bottom: 20px;
            .el-button{
                width:140px;
            }
        }
    }
</style>
